import { createAsyncAction, deprecated } from 'typesafe-actions';

import * as types from './profile.actionTypes';

const { createStandardAction } = deprecated;

export const fetchProfileAsync = createAsyncAction(
	types.FETCH_PROFILE_REQUEST,
	types.FETCH_PROFILE_SUCCESS,
	types.FETCH_PROFILE_FAILURE
)<{ userID: string; token: string }, { user: Record<string, any> }, { error: string }>();

export const clearProfile = createStandardAction(types.CLEAR_PROFILE)();
